// Template HTML de cotización como string
// Exportado desde Cotizaciones/pdf/cotizacion-template.html
// Este archivo debe ser IDÉNTICO al HTML para mantener consistencia
// Última sincronización: 2024

const cotizacionTemplateHtml = `<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>COT-XXXX - CLIENTE</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        
        body {
            font-family: "Arial", Times, serif;
            font-size: 12px;
            line-height: 1.3;
            color: #000;
            background: #fff;
            padding: 15px;
        }
        
        .document {
            width: 100%;
            max-width: 800px;
            margin: 0 auto;
            border: 1px solid transparent;
            padding: 20px;
        }
        
        .header-company-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
        }
        
        .company-section {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 50%;
        }
        
        .header {
            text-align: right;
            font-size: 12px;
            font-weight: bold;
            line-height: 1.5;
        }
        
        .header-row {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 3px;
        }
        
        .header-label {
            font-weight: bold;
            margin-right: 5px;
        }
        
        .field-value {
            font-family: "Arial", Times, serif;
            font-size: 12px;
            color: #000;
            display: inline-block;
            min-width: 20px;
        }
        
        .header-value {
            width: 90px;
            text-align: left;
            font-weight: bold;
        }
        
        .client-value {
            width: 100%;
            display: inline-block;
        }
        
        .table-value {
            width: 100%;
            display: block;
            min-height: 1.3em;
        }
        
        .table-value.cantidad { text-align: center; }
        .table-value.precio { text-align: left; }
        .table-value.total { text-align: left; font-weight: bold; }
        
        .footer-value {
            max-width: 280px;
            display: inline-block;
        }
        
        .client-section {
            margin: 15px 0;
            width: 100%;
        }
        
        .client-row-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 4px;
        }
        
        .client-data-left {
            width: 50%;
            padding-left: 60px;
        }
        
        .client-contact-right {
            width: 48%;
            text-align: left;
        }
        
        .client-row {
            margin-bottom: 3px;
            display: flex;
            align-items: flex-start;
        }
        
        .client-label {
            font-weight: bold;
            font-size: 11px;
            white-space: nowrap;
            margin-right: 5px;
            flex-shrink: 0;
        }
        
        .concepto-container {
            margin-top: 0;
            padding-top: 0;
            padding-left: 60px;
        }
        
        .title {
            text-align: center;
            font-size: 18px;
            font-weight: bold;
            margin: 20px 0 15px 0;
            letter-spacing: 2px;
        }
        
        table {
            width: 100%;
            border-collapse: collapse;
            margin: 15px 0;
            font-size: 11px;
        }
        
        th {
            background-color: #f5f5f5;
            border: none;
            padding: 6px 5px;
            text-align: left;
            font-weight: bold;
            font-size: 10px;
        }
        
        td {
            padding: 4px 5px;
            vertical-align: top;
        }
        
        .col-cantidad { 
            width: 10%; 
            text-align: center;
            border-bottom: 1px solid #000;
        }
        .col-descripcion { 
            width: 55%; 
            text-align: left; 
            border-bottom: 1px solid #000; 
        }
        .col-precio { 
            width: 17%; 
            text-align: left; 
            border-bottom: 1px solid #000;
            justify-content: start; 
        }
        .col-total { 
            width: 18%; 
            text-align: left; 
            border-bottom: 1px solid #000; 
        }
        
        .item-row td {
            border-bottom: 1px solid #000;
            height: auto;
            min-height: 22px;
        }
        
        .total-section {
            text-align: right;
            font-weight: bold;
            font-size: 14px;
            margin-top: 15px;
            padding-right: 10px;
        }
        
        .grand-total {
            font-weight: bold;
        }
        
        .spacer-large {
            height: 120px;
        }
        
        .footer-data {
            font-size: 11px;
            margin-top: 40px;
        }
        
        .footer-row {
            margin-bottom: 4px;
            display: flex;
            align-items: flex-start;
        }
        
        .footer-label {
            display: inline-block;
            width: 130px;
            font-weight: bold;
            flex-shrink: 0;
        }

        .note-section {
            margin-top: 20px;
            font-size: 11px;
            font-style: italic;
            color: #333;
        }

        .field-value:empty::before {
            content: attr(data-placeholder);
            color: #666;
            opacity: 0.6;
            font-style: italic;
        }

        @media print {
            body { padding: 0; font-size: 10px; }
            .document { border: none; padding: 10px; max-width: 100%; min-height: 100vh; position: relative; padding-bottom: 120px; }
            .header-company-row { margin-bottom: 8px; }
            .client-section { margin: 6px 0; }
            .title { margin: 8px 0; font-size: 16px; }
            table { margin: 6px 0; }
            .item-row td { border-bottom: 1px solid #808382; padding: 2px 4px; height: 18px; min-height: 18px; }
            .spacer-large { display: none !important; }
            .footer-data { 
                font-size: 9px; 
                position: absolute; 
                bottom: 10px; 
                left: 10px; 
                right: 10px;
                margin-top: 0;
            }
            .footer-row { margin-bottom: 2px; }
            .note-section { font-style: italic; margin-top: 6px; font-size: 8px; }
            .total-section { margin-top: 20px; margin-bottom: 20px; font-size: 11px; text-align: right; }
            .field-value:empty::before { display: none; }
            .no-print { display: none !important; }
        }
        
        .action-bar {
            text-align: right;
            margin-bottom: 20px;
            padding: 10px;
            background: #f8f9fa;
            border-radius: 8px;
            display: flex;
            justify-content: flex-end;
            gap: 10px;
        }
        
        .btn {
            padding: 8px 16px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            font-weight: bold;
            font-size: 13px;
        }
        
        .btn-print { background: #3b82f6; color: white; }
        .btn-download { background: #10b981; color: white; }
    </style>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
</head>
<body>
    <!-- BARRA DE ACCIONES PARA MODO STANDALONE -->
    <div class="action-bar no-print" id="action-bar">
        <button class="btn btn-print" onclick="window.print()">Imprimir</button>
        <button class="btn btn-download" onclick="window.descargarPDF()">Descargar PDF</button>
    </div>

    <div class="document" id="cotizacion-document">
        <!-- HEADER: Datos de la cotización -->
        <div class="header-company-row">
            <div class="company-section"
                style="justify-content: flex-center; flex-direction: column; align-items: flex-start;">
                <img id="company-logo" src="/Logo GAMAN.png" alt="Logo Empresa"
                    style="max-width: 400px; max-height: 120px; width: 100%; display: block; margin-bottom: 10px; object-fit: contain; object-position: left;">
            </div>
            
            <div class="header">
                <div class="header-row">
                    <span class="header-label">COT:</span>
                    <span style="margin-right: 19px;" class="field-value header-value" id="cot-numero" data-placeholder="N°"></span>
                </div>
                <div class="header-row">
                    <span class="header-label">FECHA:</span>
                    <span style="margin-right: 2px;" class="field-value header-value" id="cot-fecha" data-placeholder="DD/MM/AA"></span>
                </div>
            </div>
        </div>
        
        <!-- DATOS DEL CLIENTE -->
        <div class="client-section">
            <div class="client-row-container">
                <div class="client-data-left">
                    <div class="client-row">
                        <span style="margin-left: 41px;" class="client-label">Cliente:</span>
                        <span class="field-value client-value" id="cli-nombre" data-placeholder="Empresa"></span>
                    </div>
                    <div class="client-row">
                        <span style="margin-left: 60px;" class="client-label">Rif:</span>
                        <span class="field-value client-value" id="cli-rif" data-placeholder="J-12345678-9"></span>
                    </div>
                    <div class="client-row">
                        <span class="client-label">Dirección Fiscal:</span>
                        <span class="field-value client-value" id="cli-direccion" data-placeholder="Calle, edificio, piso, ciudad"></span>
                    </div>
                </div>
                
                <div class="client-contact-right">
                    <div class="client-row">
                        <span style="margin-left: 100px;" class="client-label">Contacto:</span>
                        <span class="field-value client-value" id="cont-nombre" data-placeholder="Nombre"></span>
                    </div>
                    <div class="client-row">
                        <span style="margin-left: 130px;" class="client-label">Tel:</span>
                        <span class="field-value client-value" id="cont-telefono" data-placeholder="0412-0000000"></span>
                    </div>
                    <div class="client-row">
                        <span style="margin-left: 111px;" class="client-label">Correo:</span>
                        <span class="field-value client-value" id="cont-email" data-placeholder="email@empresa.com"></span>
                    </div>
                </div>
            </div>
            
            <div class="concepto-container">
                <div class="client-row">
                    <span style="margin-left: 30px;" class="client-label">Concepto:</span>
                    <span class="field-value client-value" id="cot-concepto" data-placeholder="Descripción del sistema/producto"></span>
                </div>
            </div>
        </div>
        
        <div class="title">COTIZACIÓN</div>
        
        <!-- TABLA DE ÍTEMS - 12 filas fijas -->
        <table id="tabla-cotizacion">
            <thead>
                <tr>
                    <th class="col-cantidad">Cantidad</th>
                    <th class="col-descripcion">Descripción</th>
                    <th  class="col-precio">Precio Unitario</th>
                    <th class="col-total">Total</th>
                </tr>
            </thead>
            <tbody>
                <!-- Fila 1 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-1-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-1-desc"></span></td>
                    <td  class="col-precio"><span class="field-value table-value precio" id="item-1-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-1-total"></span></td>
                </tr>
                <!-- Fila 2 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-2-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-2-desc"></span></td>
                    <td class="col-precio"><span class="field-value table-value precio" id="item-2-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-2-total"></span></td>
                </tr>
                <!-- Fila 3 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-3-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-3-desc"></span></td>
                    <td class="col-precio"><span class="field-value table-value precio" id="item-3-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-3-total"></span></td>
                </tr>
                <!-- Fila 4 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-4-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-4-desc"></span></td>
                    <td class="col-precio"><span class="field-value table-value precio" id="item-4-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-4-total"></span></td>
                </tr>
                <!-- Fila 5 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-5-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-5-desc"></span></td>
                    <td class="col-precio"><span class="field-value table-value precio" id="item-5-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-5-total"></span></td>
                </tr>
                <!-- Fila 6 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-6-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-6-desc"></span></td>
                    <td class="col-precio"><span class="field-value table-value precio" id="item-6-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-6-total"></span></td>
                </tr>
                <!-- Fila 7 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-7-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-7-desc"></span></td>
                    <td class="col-precio"><span class="field-value table-value precio" id="item-7-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-7-total"></span></td>
                </tr>
                <!-- Fila 8 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-8-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-8-desc"></span></td>
                    <td class="col-precio"><span class="field-value table-value precio" id="item-8-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-8-total"></span></td>
                </tr>
                <!-- Fila 9 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-9-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-9-desc"></span></td>
                    <td class="col-precio"><span class="field-value table-value precio" id="item-9-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-9-total"></span></td>
                </tr>
                <!-- Fila 10 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-10-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-10-desc"></span></td>
                    <td class="col-precio"><span class="field-value table-value precio" id="item-10-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-10-total"></span></td>
                </tr>
                <!-- Fila 11 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-11-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-11-desc"></span></td>
                    <td class="col-precio"><span class="field-value table-value precio" id="item-11-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-11-total"></span></td>
                </tr>
                <!-- Fila 12 -->
                <tr class="item-row">
                    <td class="col-cantidad"><span class="field-value table-value cantidad" id="item-12-cant"></span></td>
                    <td class="col-descripcion"><span class="field-value table-value" id="item-12-desc"></span></td>
                    <td class="col-precio"><span class="field-value table-value precio" id="item-12-precio"></span></td>
                    <td class="col-total"><span class="field-value table-value total" id="item-12-total"></span></td>
                </tr>
            </tbody>
        </table>
        
        <!-- TOTAL GENERAL -->
        <div class="total-section">
            TOTAL: <span class="grand-total field-value" id="cot-total" data-placeholder="$ 0.00"></span>
        </div>
        
        <div class="spacer-large"></div>
        
        <!-- FOOTER -->
        <div class="footer-data">
            <div class="footer-row">
                <span class="footer-label">Método de pago:</span>
                <span class="field-value footer-value" id="foot-pago" data-placeholder="Contado/Crédito"></span>
            </div>
            <div class="footer-row">
                <span class="footer-label">Realizado por:</span>
                <span class="field-value footer-value" id="foot-vendedor" data-placeholder="Vendedor"></span>
            </div>
            <div class="footer-row">
                <span class="footer-label">Condiciones:</span>
                <span class="field-value footer-value" id="foot-condiciones" data-placeholder="Términos de pago"></span>
            </div>
            
            <div class="note-section">
                <strong>Nota:</strong> Precio no incluye I.V.A el cual se aplicará al momento de la facturación.
            </div>
        </div>
        

    </div>

    <!-- SCRIPT DE INYECCIÓN DE DATOS -->
    <script>
        /**
         * FUNCIÓN GLOBAL para poblar la cotización con datos del backend
         * @param {Object} data - Objeto con la estructura definida por el backend
         */
        window.renderCotizacion = function(data) {
            console.log('renderCotizacion recibio:', data);
            console.log('gran_total valor:', data.gran_total, 'tipo:', typeof data.gran_total);
            
            // Helper seguro para asignar texto
            const set = (id, value) => {
                const el = document.getElementById(id);
                console.log('Set #' + id + ' =', value, '- elemento:', el ? 'encontrado' : 'NO ENCONTRADO');
                if (el && value !== undefined && value !== null) {
                    el.textContent = value;
                }
            };

            // Header
            set('cot-numero', data.numero_cotizacion);
            set('cot-fecha', data.fecha_cotizacion);
            
            // Cliente
            set('cli-nombre', data.cliente_nombre);
            set('cli-rif', data.cliente_rif);
            set('cli-direccion', data.cliente_direccion);
            
            // Contacto
            set('cont-nombre', data.contacto_nombre);
            set('cont-telefono', data.contacto_telefono);
            set('cont-email', data.contacto_email);
            
            // Concepto
            set('cot-concepto', data.concepto);
            
            // Items (array de máximo 12 objetos)
            if (data.items && Array.isArray(data.items)) {
                data.items.slice(0, 12).forEach((item, idx) => {
                    const i = idx + 1;
                    set('item-' + i + '-cant', item.cantidad);
                    set('item-' + i + '-desc', item.descripcion);
                    set('item-' + i + '-precio', item.precio_unitario);
                    set('item-' + i + '-total', item.total);
                });
            }
            
            // Total - Calcular con IVA (16%)
            const IVA_RATE = 0.16;
            let subtotal = 0;

            // Si gran_total es número, usarlo directamente. Si es string, parsearlo
            if (typeof data.gran_total === 'number') {
                subtotal = data.gran_total;
            } else if (data.gran_total) {
                // Parsear string formateado (quitar US$, espacios, comas)
                let granTotalStr = String(data.gran_total).replace(/US\$|[\s]/gi, '');
                granTotalStr = granTotalStr.replace(/,/g, '');
                subtotal = parseFloat(granTotalStr) || 0;
            }

            const totalConIva = subtotal * (1 + IVA_RATE);
            console.log('Calculo total - subtotal:', subtotal, 'IVA:', IVA_RATE, 'totalConIva:', totalConIva);

            // Formatear valor como moneda
            const formatCurrency = (value) => {
                return 'US$ ' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            };

            const totalFormateado = formatCurrency(totalConIva);
            console.log('Total formateado:', totalFormateado);
            set('cot-total', totalFormateado);
            
            // Footer
            set('foot-pago', data.metodo_pago);
            set('foot-vendedor', data.vendedor);
            set('foot-condiciones', data.condiciones_pago);
            
            // Actualizar título de página
            if (data.numero_cotizacion) {
                document.title = 'COT-' + data.numero_cotizacion + ' - ' + (data.cliente_nombre || 'CLIENTE');
            }

            // Ocultar barra de acciones si estamos dentro de un iframe, ya que el padre lo controla
            if (window !== window.top) {
                const actionBar = document.getElementById('action-bar');
                if (actionBar) actionBar.style.display = 'none';
            }
        };

        /**
         * Función para descargar el documento como PDF
         */
        window.descargarPDF = function() {
            // Ocultar barra de botones en el PDF si es necesario (ya tiene .no-print pero html2pdf requiere excluir a veces)
            const element = document.getElementById('cotizacion-document');
            const opt = {
              margin:       [0.5, 0.5, 0.5, 0.5],
              filename:     document.title + '.pdf',
              image:        { type: 'jpeg', quality: 0.98 },
              html2canvas:  { scale: 2, useCORS: true },
              jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
            };
            
            // Si html2pdf está disponible
            if (typeof html2pdf !== 'undefined') {
                html2pdf().set(opt).from(element).save();
            } else {
                alert('La librería para generar PDF no está cargada.');
            }
        };

    </script>
</body>
</html>`;

export default cotizacionTemplateHtml;
